import { render, staticRenderFns } from "./AngelinvestmentPop.vue?vue&type=template&id=407c2c36&scoped=true&"
import script from "./AngelinvestmentPop.vue?vue&type=script&lang=js&"
export * from "./AngelinvestmentPop.vue?vue&type=script&lang=js&"
import style0 from "./AngelinvestmentPop.vue?vue&type=style&index=0&id=407c2c36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407c2c36",
  null
  
)

export default component.exports